export const getDgBannerApi = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.DG_BANNER_API;
};

export const isDataGrailLoaded = () => getDgBannerApi() !== undefined;

export const showConsentBanner = () => {
  const api = getDgBannerApi();
  if (!api) {
    return;
  }
  api.showConsentBanner();
};

export const setEssentialOnlyConsent = () => {
  const api = getDgBannerApi();
  if (!api) {
    return false;
  }
  api.setConsentPreferences(
    {
      essential: true,
      performance: false,
      advertising: false,
      functional: false,
    },
    {runPreferenceCallbacks: true}
  );
  return true;
};
